// src/pages/TicketStockOverview/index.tsx
// Trang "Tồn kho vé theo kế hoạch" — tách riêng khỏi Giao vé cho đại lý (REQUIRE_FIXBUGS.md mục
// 8/10): danh sách kỳ + tổng đã giao/còn lại, bấm vào xem chi tiết mở popup phiếu giao của kỳ đó.

import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import { toast } from 'react-toastify';

import BreadCrumb from 'Components/Common/BreadCrumb';
import AgentPagination from 'pages/AgentManagement/AgentPagination';
import { getTicketStockOverviewApi } from 'helpers/fakebackend_helper';
import { useBrandingTitle } from '../../hooks';

import StockOverviewList from './components/StockOverviewList';
import StockOverviewDetailModal from './modals/StockOverviewDetailModal';
import { IssuancePlanStockOverview, StockOverviewPagination } from './types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_stock_overview');

const initialPagination: StockOverviewPagination = {
  currentPage: 1,
  pageSize: 20,
  totalItems: 0,
  totalPages: 0,
};

const TicketStockOverview: React.FC = () => {
  useBrandingTitle(st('ton_kho_ve_theo_ke_hoach_text'));

  const [items, setItems] = useState<IssuancePlanStockOverview[]>([]);
  const [pagination, setPagination] = useState<StockOverviewPagination>(initialPagination);
  const [loading, setLoading] = useState(false);
  const [detailPlan, setDetailPlan] = useState<IssuancePlanStockOverview | null>(null);

  const loadItems = useCallback(() => {
    setLoading(true);
    getTicketStockOverviewApi({
      pageIndex: pagination.currentPage,
      pageSize: pagination.pageSize,
    })
      .then((response) => {
        const payload = response?.data || response;
        setItems(payload?.items || payload?.data || []);
        const totalItems = payload?.totalItems ?? payload?.totalCount ?? 0;
        setPagination((prev) => ({
          ...prev,
          totalItems,
          totalPages: payload?.totalPages ?? Math.ceil(totalItems / Math.max(prev.pageSize, 1)),
        }));
      })
      .catch((error: any) => {
        toast.error(error?.message || st('khong_the_tai_danh_sach_ton_message'));
      })
      .finally(() => setLoading(false));
  }, [pagination.currentPage, pagination.pageSize]);

  useEffect(() => {
    loadItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage, pagination.pageSize]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={st('ton_kho_ve_theo_ke_hoach_text')} pageTitle={st('quan_ly_phat_hanh_text')} />

          <Card id="ticketStockOverview">
            <CardHeader className="card-header border-0">
              <Row className="align-items-center gy-3">
                <div className="col-sm">
                  <h5 className="card-title mb-0">{st('ton_kho_ve_theo_ke_hoach_title')}</h5>
                </div>
                <div className="col-sm-auto">
                  <span className="text-muted">
                    {st('tong_text')} <span className="fw-semibold">{pagination.totalItems}</span> {st('ke_hoach_text')}
                  </span>
                </div>
              </Row>
            </CardHeader>
            <CardBody className="pt-0">
              <StockOverviewList
                items={items}
                pagination={pagination}
                loading={loading}
                onViewDetail={(item) => setDetailPlan(item)}
              />

              <AgentPagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                totalItems={pagination.totalItems}
                pageSize={pagination.pageSize}
                onPageChange={(page) => setPagination((prev) => ({ ...prev, currentPage: page }))}
              />
            </CardBody>
          </Card>
        </Container>
      </div>

      <StockOverviewDetailModal
        isOpen={!!detailPlan}
        planId={detailPlan?.issuancePlanId ?? null}
        planCode={detailPlan?.planCode}
        onClose={() => setDetailPlan(null)}
      />
    </React.Fragment>
  );
};

export default TicketStockOverview;
